import { render, staticRenderFns } from "./SideNavUser.vue?vue&type=template&id=6c359bf2&scoped=true&"
import script from "./SideNavUser.vue?vue&type=script&lang=js&"
export * from "./SideNavUser.vue?vue&type=script&lang=js&"
import style0 from "./SideNavUser.vue?vue&type=style&index=0&id=6c359bf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c359bf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VIcon,VImg,VList,VListItem,VListItemIcon,VListItemTitle,VNavigationDrawer})
